import React from 'react';
import { ActionProp } from '../../interfaces/TableActionsProps';
import { POSICons } from '../POSIcon/POSIcon';
import POSIconButton from '../POSIconButton';

type TableActionItemProps<TData> = {
  action: ActionProp<TData>;
  item: TData;
  checkedItems?: number;
};

const TableActionIconButton = <TData,>({
  action,
  item,
  checkedItems,
}: TableActionItemProps<TData>) => {
  if (typeof action.icon !== 'string') {
    return null;
  }

  if (action.isHidden?.(item)) {
    return null;
  }

  const disabled =
    checkedItems && checkedItems > 1
      ? true
      : action.isDisabled
      ? action.isDisabled?.(item)
      : false;

  return (
    <POSIconButton
      icon={action.icon as POSICons}
      iconOnly
      inverted
      disabled={disabled}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        action.onClick(item);
      }}
    />
  );
};

export const TableActionItem = <TData,>({
  action,
  item,
  checkedItems,
}: TableActionItemProps<TData>) => {
  return (
    <>
      {typeof action.icon === 'string' ? (
        <TableActionIconButton
          checkedItems={checkedItems}
          action={action}
          item={item}
        />
      ) : (
        action.icon(item)
      )}
    </>
  );
};
